import { progressiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const GoodToKnow: Site = {
  id: 'goodto',
  logo: 'svg/goodto.svg',
  label: 'Good to Know',
  analyticsName: 'goodtoknow',
  hostname: 'goodto.com',
  platform: 'progressive',
  selector: `${progressiveVanillaSelector}, article a`,
};
